import { render, staticRenderFns } from "./CommitBuyBack.vue?vue&type=template&id=a2bb0b6e"
import script from "./CommitBuyBack.vue?vue&type=script&lang=js"
export * from "./CommitBuyBack.vue?vue&type=script&lang=js"
import style0 from "./CommitBuyBack.vue?vue&type=style&index=0&id=a2bb0b6e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CommitBuyBack.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports